import { DatoZineAuthorRecord } from '@interfaces';

import styles from './zine-author.module.scss';

type ZineAuthorProps = {
	author: DatoZineAuthorRecord;
};

export const ZineAuthor = ({ author }: ZineAuthorProps) => {
	const { name, links } = author;
	const [link] = links;

	return (
		<span className={styles.author}>
			<span className={styles.name}>{name}</span>
			{link ? (
				<a className={styles.link} href={link.url}>
					{link.label}
				</a>
			) : null}
		</span>
	);
};
